import {Action} from '@ngrx/store';
import {PagingModel} from '../models/paging-model';
import {AdminListResponse} from '../models/admin-list-response';
import {ListItem} from '../models/list-item';
import { ErrorModel } from '../models/error-model';

export const LOAD_ENTIRE_LIST = '[List] LoadEntireList';
export const LOAD_ENTIRE_LIST_COMPLETE = '[List] LoadEntireListComplete';
export const LOAD_LIST_ITEM = '[List] LoadItem';
export const LOAD_LIST_ITEM_COMPLETE = '[List] LoadItemComplete';
export const SAVE_LIST_ITEM = '[List] SaveItem';
export const SAVE_LIST_ITEM_COMPLETE = '[List] SaveItemComplete';
export const LOAD_STATE_LIST = '[List] LoadStateList';
export const LOAD_STATE_LIST_COMPLETE = '[List] LoadStateListComplete';

export class LoadEntireListAction implements Action {
  readonly type = LOAD_ENTIRE_LIST;

  constructor(public payload: PagingModel) {}
}

export class LoadEntireListCompleteAction implements Action {
  readonly type = LOAD_ENTIRE_LIST_COMPLETE;

  constructor(public payload: AdminListResponse) {}
}

export class LoadListItemAction implements Action {
  readonly type = LOAD_LIST_ITEM;

  constructor(public payload: number) {}
}

export class LoadListItemCompleteAction implements Action {
  readonly type = LOAD_LIST_ITEM_COMPLETE;

  constructor(public payload: ListItem) {}
}

export class SaveListItemAction implements Action {
  readonly type = SAVE_LIST_ITEM;

  constructor(public payload: ListItem) {}
}

export class SaveListItemCompleteAction implements Action {
  readonly type = SAVE_LIST_ITEM_COMPLETE;

  constructor(public payload: ListItem) {}
}

export class LoadStateListAction implements Action {
  readonly type = LOAD_STATE_LIST;
}

export class LoadStateListCompleteAction implements Action {
  readonly type = LOAD_STATE_LIST_COMPLETE;

  constructor(public payload: ListItem[]) {}
}

export type Actions = LoadEntireListAction |
    LoadEntireListCompleteAction |
    LoadListItemAction |
    LoadListItemCompleteAction |
    SaveListItemAction |
    SaveListItemCompleteAction |
    LoadStateListAction |
    LoadStateListCompleteAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/actions/list.ts